export const PASSWORD_RULE =
  "Must be at least 8 characters and include an uppercase letter, a number and a symbol.";

export function checkPassword(pw) {
  if (!pw || pw.length < 8) return "Password must be at least 8 characters";
  if (!/[A-Z]/.test(pw)) return "Password must include at least one uppercase letter";
  if (!/[0-9]/.test(pw)) return "Password must include at least one number";
  if (!/[^A-Za-z0-9]/.test(pw)) return "Password must include at least one symbol";
  return null;
}
